/**
 * Build a WebSocket URL from VITE_API_URL (production API host).
 * Falls back to the page origin so local Vite proxy can serve `/ws`.
 */
export function wsUrl(path: string): string {
  const raw = (import.meta.env.VITE_API_URL as string | undefined)?.trim();
  const api = raw && raw.length > 0 ? raw : window.location.origin;
  const u = new URL(api);
  u.protocol = u.protocol === 'https:' ? 'wss:' : 'ws:';
  // Ensure path is absolute and drop any leftover search/hash from the API base.
  u.pathname = path.startsWith('/') ? path : `/${path}`;
  u.search = '';
  u.hash = '';
  return u.toString();
}
